const logWithTimestamp = (message, additionalInfo) => {
  const timestamp = new Date().toISOString();
  if (additionalInfo !== undefined) {
    console.log(`${timestamp} - ${message} - ${additionalInfo}`);
  } else {
    console.log(`${timestamp} - ${message}`);
  }
};

export default logWithTimestamp;
